// HubSpot's tracking code records a page view when it loads, but Gatsby swaps
// pages client-side on in-site navigation, so those views are tracked by hand.
// https://developers.hubspot.com/docs/api/events/tracking-code#tracking-in-single-page-applications

const getTrackedPath = ({ pathname, search }) => `${pathname}${search}`

const trackHubSpotPageView = (path) => {
  const queue = window._hsq
  // _hsq is created by the HubSpot plugin's snippet, which only renders in production builds.
  if (!Array.isArray(queue)) return false

  if (queue.push !== Array.prototype.push) {
    // HubSpot has loaded and replaced push, so commands run straight away.
    queue.push(['setPath', path])
    queue.push(['trackPageView'])
    return true
  }

  // HubSpot hasn't loaded yet. When it does it runs every queued setPath ahead of
  // its own initial page view, which would credit the landing page's view to this
  // path. A queued callback runs after that initial view instead.
  queue.push((tracker) => {
    tracker.setPath(path)
    tracker.trackPageView()
  })
  return true
}

export function trackHubSpotRouteUpdate({ location, prevLocation }) {
  // The first page load is tracked by the HubSpot snippet itself.
  if (!prevLocation) return false

  const path = getTrackedPath(location)
  // Jumping to an anchor on the same page isn't a new page view.
  if (path === getTrackedPath(prevLocation)) return false

  return trackHubSpotPageView(path)
}
